import './ProfileUtilityList.css'

/**
 * The own-profile footer: how to play on the left, settings on the right.
 *
 * A single row, not a boxed list of chevroned rows. As a box it carried the same visual weight as
 * the sections above it, which hold real data — two navigation links do not earn that. The weight
 * here comes from the text alone: one hairline above, nothing else.
 *
 * No borders, fills or pills on either label. Two adjacent pills would read as a segmented
 * control, and that pattern already means something else in this app (Settings' System/Light/Dark).
 *
 * Settings keeps its older door too: pressing the display name in the header still opens the same
 * screen. Two entry points is the ceiling, which is why there is no gear icon.
 */
export default function ProfileUtilityList({
  onOpenHowToPlay,
  onOpenSettings,
}: {
  onOpenHowToPlay: () => void
  onOpenSettings?: () => void
}) {
  return (
    <div className="profile-utility">
      <button type="button" className="profile-utility__link" onClick={onOpenHowToPlay}>
        How to play
      </button>
      <button type="button" className="profile-utility__link" onClick={onOpenSettings}>
        Settings
      </button>
    </div>
  )
}
